export const init = (mediaInfoUrl) => new Promise((resolve) => {
    if (!document.getElementById('mediainfo-js')) {
        const script = document.createElement('script');
        script.src = new URL('mediainfo.min.js', mediaInfoUrl);
        script.id = 'mediainfo-js';
        document.body.appendChild(script);
        script.onload = resolve;
    } else {
        resolve();
    }
});

export const analyze = async (file) => {
    if (window.MediaInfo) {
        const mediainfo = await window.MediaInfo();
        const readChunk = (chunkSize, offset) => new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.onload = (event) => {
                if (event.target.error) {
                    reject(event.target.error)
                }
                resolve(new Uint8Array(event.target.result))
            }
            reader.readAsArrayBuffer(file.slice(offset, offset + chunkSize))
        });
        return mediainfo.analyzeData(() => file.size, readChunk);
    }
}

export const isImage = async (file) => {
    const info = await analyze(file);
    const tracks = info.media.track.filter(track => track['@type'] !== 'General');
    return tracks.length === 1 && tracks[0]['@type'] === 'Image';
}

export const isVideo = async (file) => {
    const info = await analyze(file);
    return !!info.media.track.find(track => track['@type'] === 'Video');
}

export const isAudio = async (file) => {
    const info = await analyze(file);
    const tracks = info.media.track.filter(track => track['@type'] !== 'General');
    return tracks.length === 1 && tracks[0]['@type'] === 'Audio';
}